import React from "react";
import { COMPANY } from "@/lib/constants";

/**
 * Logo — größer, ohne Animationen.
 */
const Logo = ({ variant = "navbar", className = "" }) => {
  const sizeCls = {
    navbar:  "h-16 sm:h-20 lg:h-24",
    footer:  "h-24 sm:h-28 lg:h-32",
    compact: "h-12",
  }[variant] || "h-16";

  return (
    <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={COMPANY.logo}
        alt={`${COMPANY.name} – ${COMPANY.tagline}`}
        className={`${sizeCls} w-auto object-contain block ${
          variant === "footer" ? "brightness-0 invert" : ""
        }`}
        draggable="false"
      />
    </div>
  );
};

export default Logo;
